import { warehouseClient, extractStatusCode } from "@/infrastructure/http/warehouseClient";
import type { TypeUse, TypeUseErrorCode, ApiEnvelope } from "@/domain/types";

export function createTypeUseError(code: TypeUseErrorCode): Error {
  const err = new Error(code);
  err.name = "TypeUseError";
  return err;
}

export function isTypeUseError(err: unknown): err is Error & { message: TypeUseErrorCode } {
  return err instanceof Error && err.name === "TypeUseError";
}

export async function listTypeUses(): Promise<TypeUse[]> {
  const response = await warehouseClient.get<ApiEnvelope<TypeUse[]>>("/type-use");
  return response.data.data ?? [];
}

export async function createTypeUse(name: string): Promise<void> {
  try {
    await warehouseClient.post("/type-use", { name });
  } catch (err) {
    const code = extractStatusCode(err);
    if (code === 409) throw createTypeUseError("DUPLICATE");
    if (code === 400) throw createTypeUseError("VALIDATION");
    if (code === 403) throw createTypeUseError("FORBIDDEN");
    if (code === 401) throw createTypeUseError("UNAUTHORIZED");
    throw createTypeUseError("UNKNOWN");
  }
}

export async function updateTypeUse(id: string, name: string): Promise<void> {
  try {
    await warehouseClient.patch(`/type-use/${id}`, { name });
  } catch (err) {
    const code = extractStatusCode(err);
    if (code === 404) throw createTypeUseError("NOT_FOUND");
    if (code === 409) throw createTypeUseError("DUPLICATE");
    if (code === 400) throw createTypeUseError("VALIDATION");
    if (code === 403) throw createTypeUseError("FORBIDDEN");
    if (code === 401) throw createTypeUseError("UNAUTHORIZED");
    throw createTypeUseError("UNKNOWN");
  }
}

export async function deleteTypeUse(id: string): Promise<void> {
  try {
    await warehouseClient.delete(`/type-use/${id}`);
  } catch (err) {
    const code = extractStatusCode(err);
    if (code === 404) throw createTypeUseError("NOT_FOUND");
    if (code === 403) throw createTypeUseError("FORBIDDEN");
    if (code === 401) throw createTypeUseError("UNAUTHORIZED");
    throw createTypeUseError("UNKNOWN");
  }
}
